module.exports = __webpack_public_path__ + "img/thumb-kanapowi-buntownicy.jpg";